/**
 * Aviso de «el servidor me negó el acceso» (HTTP 403).
 *
 * **Por qué existe (prueba del founder, 1-oct-2026).** Se quitó a un miembro
 * del equipo y su ventana abierta siguió mostrando la app: el contexto de
 * onboarding (`access_revoked`) se revalida al recargar o al volver a la
 * pestaña, pero quien navega dentro de la misma ventana no dispara ninguno
 * de los dos. Cada pantalla mostraba su propio error y nada lo sacaba.
 *
 * El servidor ya dice cuándo pasa: toda ruta de datos responde 403 a quien
 * no tiene membresía activa. Aquí cualquier módulo avisa de ese 403 y
 * `MunicipalityProvider` vuelve a pedir el contexto; si dice que el acceso se
 * retiró, `OnboardingGate` lo manda a /login con el aviso. La primera
 * pantalla que falle lo expulsa, sin esperar una recarga.
 *
 * Se avisa en TODO 403, no solo en el de «no estás vinculado»: otros 403 (un
 * colaborador intentando una acción de admin) provocan una relectura barata
 * del contexto que no cambia nada. Más simple y más seguro que reconocer el
 * texto del mensaje.
 *
 * Módulo aparte y sin dependencias para que `errors.ts` (que lo dispara) y
 * `municipality.tsx` (que lo escucha) no se importen entre sí.
 */

export type AccessDeniedListener = (url: string) => void;

const listeners = new Set<AccessDeniedListener>();

/** Escucha los 403 del API. Devuelve la función para dejar de escuchar. */
export function onAccessDenied(listener: AccessDeniedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Avisa que `url` respondió 403. Un oyente que falla no afecta a los demás. */
export function notifyAccessDenied(url: string): void {
  for (const listener of [...listeners]) {
    try {
      listener(url);
    } catch (err) {
      console.error("[access-denied] un oyente falló", err);
    }
  }
}
